import { render, staticRenderFns } from "./ContactsSection.vue?vue&type=template&id=79694c02&scoped=true"
import script from "./ContactsSection.vue?vue&type=script&lang=js"
export * from "./ContactsSection.vue?vue&type=script&lang=js"
import style0 from "./ContactsSection.vue?vue&type=style&index=0&id=79694c02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79694c02",
  null
  
)

export default component.exports